// @ts-strict-ignore
import {EventDropFiltersLimitResults} from 'app_api/projects/data_definitions/types';
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint(projectId: string): string {
  return appApiUrl(`data-definitions/events/drop-filters/limits`, {projectId});
}

export const dataDropFiltersLimitClient: ApiResourceClient<EventDropFiltersLimitResults> = {
  index() {
    throw new Error(`dataDropFiltersLimitClient does not support index queries`);
  },

  get(id: string) {
    return apiClient.hydratedGet<EventDropFiltersLimitResults>(buildEndpoint(id), {
      updateFetchCache: true,
    });
  },

  purgeCache(id: string) {
    purgeFetchCache({everything: true, path: buildEndpoint(id)});
  },
};
